import { CheckinOrderFragment, CheckoutOrderFragment } from '@websky/graphql';
import { createCommonOrderSelectors } from '../lib/createCommonOrderSelectors';

type OrderStateSlice = {
	order: CheckoutOrderFragment | CheckinOrderFragment;
};

export const checkoutCommonSelectors = createCommonOrderSelectors<OrderStateSlice>(state => state.order);

export const checkinCommonSelectors = createCommonOrderSelectors<OrderStateSlice>(state => state.order);
